/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl } from '../fetch-graphql';
import { handleNetworkError } from '@/account/lib/network-error';
import { handleFetchError } from '@/account/lib/fetch-error';
import {
  ChangeCustomerPasswordProps,
  ChangeCustomerPasswordResponse,
} from '@/account/types';
import { CHANGE_CUSTOMER_PASSWORD } from './graphql/updateCustomerPassword.graphql';

export const updateCustomerPassword = async ({
  currentPassword,
  newPassword,
}: ChangeCustomerPasswordProps): Promise<string> => {
  return await fetchGraphQl(CHANGE_CUSTOMER_PASSWORD, {
    method: 'POST',
    variables: { currentPassword, newPassword },
  })
    .then((response: ChangeCustomerPasswordResponse) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return response?.data?.changeCustomerPassword?.email || '';
    })
    .catch(handleNetworkError);
};
